/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationModalIntegrations_person = {
    readonly harvestUser: boolean | null;
    readonly unit4User: boolean | null;
    readonly " $refType": "TimeRegistrationModalIntegrations_person";
};
export type TimeRegistrationModalIntegrations_person$data = TimeRegistrationModalIntegrations_person;
export type TimeRegistrationModalIntegrations_person$key = {
    readonly " $data"?: TimeRegistrationModalIntegrations_person$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TimeRegistrationModalIntegrations_person">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRegistrationModalIntegrations_person",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit4User",
      "storageKey": null
    }
  ],
  "type": "Person"
};
(node as any).hash = 'd86a4a2e47e87916081608b32d729f5c';
export default node;
